import type { ReactNode } from 'react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@rocco/components/tooltip';

interface TextTooltipProps {
    content: string;
    children: ReactNode;
}

export const TextTooltip = ({ content, children }: TextTooltipProps) => {
    if (!content) return <>{children}</>;

    return (
        <TooltipProvider delayDuration={300}>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent side="top" color="dark">
                    {content}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
